import { ConfigurationType } from './config-type.enum';
export interface Configuration {
	uuid: string;
	sensitive: boolean;
	key: string;
	type: ConfigurationType;
	value: string | string[] | boolean | object;
	updateDate?: string;
}
